import { render, staticRenderFns } from "./manyAspect.vue?vue&type=template&id=4a767965"
import script from "./manyAspect.vue?vue&type=script&lang=js"
export * from "./manyAspect.vue?vue&type=script&lang=js"
import style0 from "./manyAspect.vue?vue&type=style&index=0&id=4a767965&prod&lang=scss&socped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports